import { WatcherShortcutAllHintsClose } from '@/pages/_base/shortcuts/_watchers/watcher_shortcut_all_hints_close';
import { WatcherShortcutAllHintsVisibility } from '@/pages/_base/shortcuts/_watchers/watcher_shortcut_all_hints_visibility';
import { WatcherShortcutShowShortcutsHints } from '@/pages/_base/shortcuts/_watchers/watcher_shortcut_show_shortcuts_hints';

export function WATCHERS__container_global_after_view() {
  return (
    <>
      {/*
       * SHORTCUTS
       */}
      <WatcherShortcutShowShortcutsHints />
      <WatcherShortcutAllHintsVisibility />
      <WatcherShortcutAllHintsClose />
    </>
  );
}
